import { useEffect, useMemo, useState } from "react";
import { release } from "@/data/site";
import { useI18n } from "@/i18n/I18nProvider";

function getRemaining(targetIso: string) {
  const target = new Date(targetIso).getTime();
  const diff = Math.max(target - Date.now(), 0);
  return {
    days: Math.floor(diff / 86_400_000),
    hours: Math.floor((diff / 3_600_000) % 24),
    minutes: Math.floor((diff / 60_000) % 60),
    seconds: Math.floor((diff / 1_000) % 60)
  };
}

export function Countdown() {
  const { t } = useI18n();
  const target = release.targetDateIso;
  const [remaining, setRemaining] = useState(() => (target ? getRemaining(target) : null));

  useEffect(() => {
    if (!target) {
      return;
    }

    const timer = window.setInterval(() => setRemaining(getRemaining(target)), 1000);
    return () => window.clearInterval(timer);
  }, [target]);

  const entries = useMemo(() => {
    if (!remaining) {
      return [];
    }
    return [
      [t("countdown.days"), remaining.days],
      [t("countdown.hours"), remaining.hours],
      [t("countdown.minutes"), remaining.minutes],
      [t("countdown.seconds"), remaining.seconds]
    ];
  }, [remaining, t]);

  if (!target || !remaining) {
    return (
      <div className="countdown pending" data-reveal>
        <span>{t("countdown.pending")}</span>
        <strong>{t(release.estimatedWindowKey)}</strong>
      </div>
    );
  }

  return (
    <div className="countdown" data-reveal>
      {entries.map(([label, value]) => (
        <div className="countdown-cell" key={label}>
          <strong>{String(value).padStart(2, "0")}</strong>
          <span>{label}</span>
        </div>
      ))}
    </div>
  );
}
